import { useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { USER_INFO } from "../../redux/actions/constants";
import { getInitialCurrenciesSettingsAction } from "../../redux/actions/currenciesActions";
import { loginUserAction } from "../../redux/actions/userActions";
import { getUserInfo } from "../../services/rashTradeServices";
import { errorToastify } from "../../utils/Toastify";
import HrFillDataInput from "../common-components/HrFillDataInput";

const LoginInsert = ({ isDarkMode }) => {
    const [userNumber, setUserNumber] = useState("");
    const [userPassword, setUserPassword] = useState("");
    const [visiblePass, setVisiblePass] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const submitInfo = async () => {
        if (!userNumber.trim() || !userPassword.trim())
            return errorToastify("User creditentials are required!");
        const userInfo = {
            userNumber,
            userPassword
        };
        try {
            const {
                data: { accountName, accessToken }
            } = await getUserInfo(userInfo);
            dispatch(loginUserAction({ accountName, accessToken }));
            setTimeout(() => {
                dispatch(getInitialCurrenciesSettingsAction());
            }, 1000);
            navigate("/");
            localStorage.setItem("_expiredTime", Date.now() + 3600 * 1000);
        } catch (error) {
            return errorToastify(error.response?.data?.message || error);
        }
        // dispatch({ type: USER_INFO, payload: Token });
    };
    return (
        <div className="d-flex h-full justify-center w-full mt-24 lg:flex-2 ">
            <h2 className="w-full flex justify-center text-3xl font-semibold">Sign in</h2>
            <div
                onKeyDown={(e) => e.key === "Enter" && submitInfo()}
                className="w-full flex flex-col  justify-center items-center ">
                <div className="flex flex-col w-full items-center my-2 mt-4 relative">
                    <div className="mt-7 w-1/2 md:w-1/3 xl:w-1/4  ">
                        <input
                            onChange={(e) => setUserNumber(e.target.value)}
                            type="text"
                            maxLength={"11"}
                            placeholder="09120000000"
                            className={`bg-gray-100 w-full min-h-10  rounded-lg px-2 outline-0 ${
                                isDarkMode ? "text-[#000]" : "text-[#fff]"
                            }`}
                            name=""
                        />
                    </div>
                    <div className="relative mt-7 w-1/2 md:w-1/3 xl:w-1/4">
                        <input
                            onChange={(e) => setUserPassword(e.target.value)}
                            type={visiblePass ? "text" : "password"}
                            placeholder="**************"
                            className={`bg-gray-100 w-full min-h-10 align-middle  rounded-lg px-2 outline-0 ${
                                isDarkMode ? "text-[#000]" : "text-[#fff]"
                            }`}
                            name=""
                        />
                        <img
                            onClick={() => setVisiblePass(!visiblePass)}
                            style={{
                                top: "25%"
                            }}
                            className={`absolute cursor-pointer right-1 max-w-5 ${
                                visiblePass ? "block" : "hidden"
                            }`}
                            src={`/icons/visible.png`}
                            alt=""
                        />
                        <img
                            onClick={() => setVisiblePass(!visiblePass)}
                            style={{
                                top: "25%"
                            }}
                            className={`absolute cursor-pointer right-1 max-w-5 ${
                                !visiblePass ? "block" : "hidden"
                            }`}
                            src={`/icons/invisible.png`}
                            alt=""
                        />
                    </div>
                </div>
                <div className="mt-9 flex flex-col items-center w-full">
                    <button
                        className="bg-[#000] text-white  w-1/2 md:w-1/3 xl:w-1/4 py-2 rounded-lg "
                        onClick={() => submitInfo()}>
                        send
                    </button>
                    <p className="flex px-3 text-center mt-3">Insert your phone number to log in</p>
                    <p className="flex text-center mt-10 px-4 text-sm text-gray-400 w-1/2">
                        This website uses cookies to deliver the best possible user experience. With
                        signning up you are accepting this our terms and policies.{" "}
                    </p>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default LoginInsert;
